@let content = widgetStore.contentSg();

@if (content) {
  <div class="atn-comparison-table">
    <!-- Header row -->
    <div class="atn-comparison-table__row atn-comparison-table__row--header">
      <div
        class="atn-comparison-table__header atn-comparison-table__header--criteria"
      >
        Criteria
      </div>
      @for (competitor of content.competitors; track competitor.id) {
        <div class="atn-comparison-table__header">
          {{ competitor.name }}
        </div>
      }
    </div>
    <!-- Data rows -->
    @for (criteria of content.criteria; track criteria.id; let idx = $index) {
      <div
        class="atn-comparison-table__row"
        [class.atn-comparison-table__row--even]="idx % 2 === 1"
      >
        <div
          class="atn-comparison-table__cell atn-comparison-table__cell--criteria"
        >
          {{ criteria.name }}
        </div>
        @for (competitor of content.competitors; track competitor.id) {
          <div class="atn-comparison-table__cell">
            @let field = competitor.values[criteria.id];
            @if (field) {
              <atn-display-field [field]="field" />
            }
          </div>
        }
      </div>
    }
  </div>
}
